import PageHead from "../Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
import ContactUs from "@/my_components/_Contact/ContactUs";
import MobileMenu from "@/my_components/Header/MobileMenu";
import CourseRoom from "@/my_components/_Courses/CourseRoom";


import BackToTop from "@/my_components/BackToTop/BackToTop_1";
import { CONFIG } from "@/app_config.js";

import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";

const index = () => {


  return (

    <>

        <PageHead title="Courses | SmartTech Academy" />

            <Context>
                <MobileMenu />
                <HeaderContainer headerSticky="rbt-sticky" headerType="" />
                <CourseRoom />
                <BackToTop />

                <Separator />
                <Footer />
            </Context>
    </>

  );

};

export default index;
